<template>
  <div class="profile-card">
    <div class="profile-card__avatar--wrap">
      <div class="profile-card__avatar">
        <profile-preview-image
          :thumbnailUrl="thumbnailUrl"
          :profileId="profileIdAsNumber"
          :avatarSize="80"
        />
      </div>
      <v-file-input
        hide-input
        hide-details
        :accept="getMimeTypes(18)"
        class="profile-card__avatar-change-button"
        prepend-icon="bhi-image"
        truncate-length="15"
        @change="selectAvatar"
      ></v-file-input>
    </div>
    <div class="profile-card__name--wrap">
      <p class="profile-card__name">
        {{ profile.firstName + ' ' + profile.lastName }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { FILE_SIZE_LIMIT, FILE_SIZE_LIMIT_NAME } from '@/helpers/constants'
import ProfilePreviewImage from './ProfilePreviewImage.vue'

export default {
  components: { ProfilePreviewImage },
  name: 'ProfileCard',
  props: {
    profile: {
      type: Object,
      default: () => ({}),
    },
    getMimeTypes: {
      type: Function,
      default: () => null,
    },
  },
  computed: {
    ...mapState('userStates', ['profileId', 'user']),
    thumbnailUrl() {
      return this.user?.thumbnailUrl || this.profile?.thumbnailUrl
    },
    profileIdAsNumber() {
      return parseInt(this.profileId, 10)
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    ...mapMutations('appStates', ['setSnackbarNotification']),
    selectAvatar(file) {
      const data = { file }
      if (file.size <= FILE_SIZE_LIMIT) {
        this.$emit('updateAvatar', data)
      } else {
        this.setSnackbarNotification(
          `Max upload file size is ${FILE_SIZE_LIMIT_NAME}. Try again with smaller file.`,
        )
      }
    },
    handleLoadStart() {
      this.isLoading = true
    },
    handleLoad() {
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables';

.profile-card {
  display: flex;

  &__avatar {
    overflow: hidden;
    border-radius: $border-radius-root2 !important;

    &--wrap {
      display: flex;
      position: relative;
      margin-right: 16px;
      width: 80px;
      height: 80px;
      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }

    &-change-button {
      position: absolute;
      bottom: -8px;
      right: -8px;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: $border-radius-root;
      background: $bh-white;
      padding: 0;
      margin: 0;
      color: $bh-blue;

      .v-icon {
        color: $bh-blue;
      }

      .v-input__prepend-outer {
        margin: 0;
      }
    }
  }

  &__name {
    font-size: 1.42857rem;
    line-height: 1;
    color: $bh-blue;
    font-weight: 700;

    &--wrap {
      padding-top: 15px;
    }
  }
}
</style>
